// extracted by mini-css-extract-plugin
export var dividerContainer = "_96-0";
export var line = "_96-1";